import { render, staticRenderFns } from "./OrganizationAttrs.vue?vue&type=template&id=c61fa332"
import script from "./OrganizationAttrs.vue?vue&type=script&lang=js"
export * from "./OrganizationAttrs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports